module.exports = __webpack_public_path__ + "img/footer-text_600.2a7d844d.png";